<template>
  <div class="mine" v-if="info">
    <div class="info">
      <!-- <img :src="info.avatarPath | getavatar" class="avatarPath" /> -->
      <van-image :src="info.avatarPath | getavatar" class="avatarPath" round>
        <template v-slot:error>
          <img
            src="../../assets/img/avater.png"
            class="avatarPath"
            style="margin: 0"
          />
        </template>
      </van-image>
      <div class="msg">
        <div style="text-align: left">
          <div>
            <span class="nickName mr11">{{ info.nickName }}</span>
            <span class="jobs">{{ info.jobs[0].name }}</span>
          </div>
          <div class="mt6">{{ info.phone }}</div>
          <div class="mt5">{{ info.dept.name }}</div>
        </div>
        <van-icon
          @click="tomyinfo"
          name="play"
          size="20px"
          style="display: flex; align-items: center"
        />
      </div>
    </div>
    <div class="items">
      <van-cell-group>
        <van-cell is-link to="/myteam">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <van-image
              width="26"
              height="26"
              :src="require('../../assets/img/team.png')"
            />
            <span class="custom-title">我的团队</span>
          </template>
        </van-cell>
        <van-cell is-link to="/mycourse">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <van-image
              width="26"
              height="26"
              :src="require('../../assets/img/class.png')"
            />
            <span class="custom-title">我的课程</span>
          </template>
        </van-cell>
        <van-cell is-link to="/mycourse">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <van-image
              width="26"
              height="26"
              :src="require('../../assets/img/wenjvan.png')"
            />
            <span class="custom-title">我的问卷</span>
          </template>
        </van-cell>
        <van-cell is-link to="/mycourse">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <van-image
              width="26"
              height="26"
              :src="require('../../assets/img/exam.png')"
            />
            <span class="custom-title">我的考试</span>
          </template>
        </van-cell>
        <van-cell is-link to="/mycourse">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <van-image
              width="26"
              height="26"
              :src="require('../../assets/img/sc.png')"
            />
            <span class="custom-title">产品收藏</span>
          </template>
        </van-cell>
        <van-cell is-link to="/mycourse">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <van-image
              width="26"
              height="26"
              :src="require('../../assets/img/help.png')"
            />
            <span class="custom-title">使用帮助</span>
          </template>
        </van-cell>
        <van-cell is-link to="/mycourse">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <van-image
              width="26"
              height="26"
              :src="require('../../assets/img/about.png')"
            />
            <span class="custom-title">关于我们</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>

    <Footer page="index"></Footer>
  </div>
</template>

<script>
import { userinfo } from "../../api/apis";
import { Cell, CellGroup } from "vant";
import { getToken, removeToken } from "@/utils/auth";
import Footer from "@/components/Footer";
import { Toast } from "vant";

export default {
  name: "my",
  components: {
    Footer,
  },
  data() {
    return {
      info: "",
      baseUrl: "",
    };
  },
  methods: {
    tomyinfo() {
      this.$router.push({ path: "myinfo" });
    },
    getinfo() {
      userinfo().then((res) => {
        this.info = res;
        if (!this.$store.state.user.user.user) {
          this.$store.commit("SET_USER", { user: res });
        }
        console.log(this.$store.state.user.user);
      });
    },
  },
  mounted() {
    // this.info = this.$store.state.user.user.user;
    console.log(this.info);
    this.baseUrl = process.env.VUE_APP_URL;
    this.getinfo();
  },
  filters: {
    getavatar(val) {
      if (val && val.indexOf("http") == -1) {
        if (val.indexOf("/avatar/") == -1) {
          return process.env.VUE_APP_URL + "/avatar/" + val;
        } else {
          console.log(val.split("zlxadmin")[1]);
          return process.env.VUE_APP_URL + val.split("zlxadmin")[1];
        }
      } else {
        return val;
      }
    },
  },
};
</script>

<style  lang="less">
.mine {
  width: 100%;
  .info {
    width: 347px;
    height: 120px;
    line-height: 20px;
    border-radius: 4px;
    background-color: rgba(255, 150, 11, 100);
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 100);
    margin: 15px auto 0;
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 100);
    font-size: 14px;
    .avatarPath {
      width: 76px;
      height: 76px;
      border-radius: 4px;
      margin-left: 13px;
      margin-right: 15px;
    }
    .nickName {
      color: rgba(255, 255, 255, 100);
      font-size: 18px !important;
      font-family: PingFangSC-bold;
    }
    .msg {
      display: flex;
      align-item: center;
      justify-content: space-between;
      width: 230px;
    }
  }
  .items {
    width: 344px;
    margin: 15px auto;
    overflow: hidden;
    border-radius: 4px;
  }
  .mt6 {
    margin-top: 4px;
  }
  .mt5 {
    margin-top: 3px;
  }
  .mr11 {
    margin-right: 11px;
  }
  .van-cell__title {
    display: flex;
    align-items: center;
  }
  .custom-title {
    margin-left: 10px;
  }
}
</style>